import styled from 'styled-components';

export const FunRowItemS = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 44px;

  &:hover {
    background-color: #f3f3ff;
  }

  form {
    height: 100%;
    flex: 1;

    input {
      padding: 0 15px;
      width: 100%;
      height: calc(100% - 4px);
      background-color: #3d3bff33;
      border-radius: 4px;
      border: none;
      margin-left: 2px;
      color: #5c5d61;

      font-size: 16px;
      font-weight: 500;
      line-height: 19.41px;
      text-align: left;

      outline: none !important;
      border: none !important;
    }
  }

  .init-row {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    label {
      display: flex;
      padding: 2px 0 2px 12px;
      align-items: center;
      gap: 10px;

      span {
        // width: 100px;
        height: 27px;
        border-radius: 7px;
        background: #3d3bff33;
        display: flex;

        padding: 2px 12px;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        color: #5c5d61;

        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        text-align: center;
      }

      input {
        display: none;
        outline: none;
        border: none;
      }
    }

    span {
      padding: 0 15px;
      font-weight: 600;
    }
  }

  .popover_toggler {
    width: 26px;
    height: 26px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: transparent;
    border: none;
    cursor: pointer;
    border-radius: 4px;
    margin: 0 10px 0 5px;

    &:hover {
      background-color: #3d3bff33;
    }
  }
`;

export const ContextMenu = styled.ul`
  list-style: none;
  width: 148px;
  border: 1px solid #7888f5;
  border-radius: 10px;
  padding: 0;
  background-color: #fff;
  z-index: 123;
  overflow: hidden;
  box-shadow:
    0px 7px 15px 0px #0000001a,
    0px 27px 27px 0px #00000017,
    0px 62px 37px 0px #0000000d,
    0px 110px 44px 0px #00000003,
    0px 171px 48px 0px #00000000;

  li {
    &:hover {
      background-color: #f3f3ff;
    }

    &:not(:last-child) {
      border-bottom: 1px solid #e2e2e2;
    }

    button {
      background: transparent;
      border: none;
      outline: none;

      cursor: pointer;
      width: 100%;
      height: 43px;
      padding: 14px 16px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      gap: 8px;
      font-size: 16px;
      font-weight: 400;
      line-height: 19.09px;
      text-align: left;
    }

    svg {
      width: 16px !important;
      height: 16px !important;

      path {
        stroke: #7888f5;
      }
    }
  }
`;

export const RightActions = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;

  .edit-jursidiction__btn {
    display: flex;
    gap: 8px;
    color: #228be6;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%; /* 19.6px */
  }
`;
